import React, { useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// Rebranding 2026 · sezioni next-app/club-app/footer rifatte come gc-notice / gc-bannerapp / gc-footer2

export default function Layout({ children }) {
  //Gestione della traduzione del sito
  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        includedLanguages: "it,en",
        pageLanguage: "it",
        autoDisplay: false,
      },
      "google_translate_element",
    );
  };
  useEffect(() => {
    const addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit",
    );
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;
  }, []);

  return (
    <Root>
      <Children>{children}</Children>

      {/* Rebranding 2026 · alert istituzionale (Next Appennino) come gc-notice neutro */}
      <section className="gc-wrap gc-wrap--section-sm">
        <div className="gc-notice">
          <span className="gc-notice__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
            </svg>
          </span>
          <div className="gc-notice__body">
            <p className="gc-notice__text gc-notice__text--italic">
              Giocamondo Study sta investendo nella digitalizzazione dei processi aziendali per ottimizzare l’efficacia, coinvolgere i consumatori e rimanere competitiva. L’obiettivo è passare da processi efficaci a processi efficienti, attraverso una revisione e l’implementazione di soluzioni digitali standardizzate.
            </p>
            <div className="gc-bannerapp__logos gc-bannerapp__logos--spaced">
              <img alt="Next Appennino" src="https://www.giocamondostudy.it/wp-content/uploads/2022/03/NEXT-APPENNINO-ai-Google-Drive.png" />
              <img alt="Commissario Sisma 2016" src="https://www.giocamondostudy.it/wp-content/uploads/2022/03/logo_ComSisma2016_DEF-ai-Google-Drive.png" />
              <img alt="Struttura di Missione" src="https://www.giocamondostudy.it/wp-content/uploads/2022/03/images.jpg" />
            </div>
          </div>
        </div>
      </section>

      {/* Rebranding 2026 · banner mobile app · gc-bannerapp */}
      <section className="gc-wrap gc-wrap--section-md">
        <div className="gc-bannerapp">
          <div className="gc-bannerapp__text">
            <p className="gc-bannerapp__eyebrow">Giocamondo Club Mobile</p>
            <p className="gc-bannerapp__title">
              Scarica l’app dell’area riservata Giocamondo Club! I nostri servizi e l’innovazione nel palmo di una mano.
            </p>
          </div>
          <div className="gc-bannerapp__stores">
            <a href="https://play.google.com/store/apps/details?id=it.club.giocamondo&hl=it_IT" target="_blank" rel="noopener noreferrer" title="Scarica App Giocamondo Club su Google Play">
              <img alt="Google Play" src="https://www.giocamondostudy.it/wp-content/uploads/2024_ClubGoogle_btn.png" />
            </a>
            <a href="https://apps.apple.com/it/app/giocamondo-club/id6447257466" target="_blank" rel="noopener noreferrer" title="Scarica App Giocamondo Club su Apple Store">
              <img alt="App Store" src="https://www.giocamondostudy.it/wp-content/uploads/2024_ClubApple_btn.png" />
            </a>
          </div>
        </div>
      </section>

      {/* Rebranding 2026 · footer antracite · gc-footer2 */}
      <footer className="gc-footer2">
        <div className="gc-footer2__inner">
          <img
            className="gc-footer2__logo"
            alt="Go-munity"
            src={require("../assets/logo-go-munity-white.png")}
          />
          <div id="google_translate_element" className="gc-footer2__translate" />
          <p className="gc-footer2__eyebrow">Per assistenza</p>
          <a className="gc-footer2__contact" href="tel:0736343440">0736.343440 — 0736.336339</a>
          <a className="gc-footer2__mail" href="mailto:club@giocamondo.it">club@giocamondo.it</a>
          <div className="gc-footer2__reg-wrap">
            <a className="gc-footer2__reg" href="http://giocamondo.it/club" target="_blank" rel="noopener noreferrer">
              Maggiori informazioni e regolamento GiocamondoClub →
            </a>
          </div>
          <div className="gc-footer2__policy gc-footer2__policy--wrap">
            <a
              href={process.env.PUBLIC_URL + "/docs/dichiarazione-accessibilita-giocamondo-study-spa.pdf"}
              target="_blank"
              rel="noopener noreferrer"
              download
              title="Dichiarazione accessibilità Giocamondo Study Spa"
            >
              Dichiarazione accessibilità Giocamondo Study Spa
            </a>
            <a
              href={process.env.PUBLIC_URL + "/docs/dichiarazione-accessibilita-giocamondo-scspa.pdf"}
              target="_blank"
              rel="noopener noreferrer"
              download
              title="Dichiarazione accessibilità Giocamondo scspa"
            >
              Dichiarazione accessibilità Giocamondo scspa
            </a>
          </div>
          <div className="gc-footer2__policy">
            <a href="https://www.iubenda.com/privacy-policy/883329" className="iubenda-white no-brand iubenda-embed" title="Privacy Policy">
              Privacy Policy
            </a>
            <a href="https://www.iubenda.com/privacy-policy/883329/cookie-policy" className="iubenda-white no-brand iubenda-embed" title="Cookie Policy">
              Cookie Policy
            </a>
            <a href="#" className="iubenda-cs-preferences-link">
              Aggiorna i consensi
            </a>
          </div>
        </div>
      </footer>
    </Root>
  );
}

Layout.propTypes = {
  children: PropTypes.element,
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--gc-page, #FAFAF8);
`;

const Children = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;
